var _path, _path2, _path3, _path4, _path5, _circle, _ellipse, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredInternationalWire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 17L32 11C32 10.4477 31.5522 10 30.9999 10H5.44995C4.89767 10 4.44995 10.4477 4.44995 11V28C4.44995 28.5523 4.89767 29 5.44995 29H16.4281L24.8141 29",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10V10C11 13.3137 8.31371 16 5 16L4 16",
    stroke: "#20242E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10V10C25 13.866 28.134 17 32 17V17",
    stroke: "#20242E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29V29C11 25.6863 8.31371 23 5 23H4",
    stroke: "#20242E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15C17.1193 15 16 15.8954 16 17C16 18.1046 16.8333 19 18.5 19C20.1667 19 21 19.8954 21 21C21 22.1046 19.8807 23 18.5 23M18.5 15C19.4253 15 20.2333 15.4022 20.6655 16M18.5 15V14M18.5 23L18.5 24M18.5 23C17.5747 23 16.7667 22.5978 16.3345 22",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 24,
    r: 5,
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 24,
    rx: 2,
    ry: 5,
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24H36",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredInternationalWire);
export default __webpack_public_path__ + "static/media/ic-colored-international-wire.f85941863dfa1661ee0cf8967b44926f.svg";
export { ForwardRef as ReactComponent };